import {
  PatientSync,
  SyncServiceType,
  SyncState,
} from "model/patient-sync.model";
import { api } from "api/base-config";

export const findPatientSync = async (
  caregiverId: number,
  patientId: number
): Promise<PatientSync[]> => {
  return api
    .get(
      `/resources/secured/rs/patients/${patientId}/caregivers/${caregiverId}/patientsync/all`
    )
    .then((response) =>
      response.data.map((dto: PatientSyncDto) => mapFromDtoToModel(dto))
    );
};

export const patientSyncCreate = async (
  caregiverId: number,
  patientId: number,
  syncServiceType: SyncServiceType
): Promise<any> => {
  return api
    .post(
      `/resources/secured/rs/patients/${patientId}/caregivers/${caregiverId}/patientsync`,
      mapToPatientSyncDto(syncServiceType, SyncState.FINISHED)
    )
    .then((response) => mapFromDtoToModel(response.data));
};

interface PatientSyncDTO {
  readonly "@type": "PatientSync";
  readonly serviceType: SyncServiceType;
  readonly syncState: SyncState;
}

const mapToPatientSyncDto = (
  serviceType: SyncServiceType,
  syncState: SyncState
): PatientSyncDTO => {
  return Object.assign({} as PatientSyncDTO, {
    "@type": "PatientSync",
    serviceType: serviceType,
    syncState: syncState,
  });
};

const mapFromDtoToModel = (patientSyncDto: PatientSyncDto): PatientSync => {
  let patientSync = new PatientSync();
  patientSync.id = patientSyncDto.id;
  patientSync.syncState = patientSyncDto.syncState;
  patientSync.lastSyncState = patientSyncDto.lastSyncState;
  patientSync.syncServiceType = patientSyncDto.serviceType;
  return patientSync;
};

export interface PatientSyncDto {
  id: number;
  lastSyncState: Date;
  serviceType: SyncServiceType;
  syncState: SyncState;
}
